"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _filterContext = _interopRequireDefault(require("../context/filterContext"));
var _useFilterAPI = _interopRequireDefault(require("../hooks/useFilterAPI"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Filter = function Filter(_ref) {
  var api = _ref.api,
    children = _ref.children,
    _ref$excludedFilter = _ref.excludedFilter,
    excludedFilter = _ref$excludedFilter === void 0 ? [] : _ref$excludedFilter,
    _ref$filterOnChange = _ref.filterOnChange,
    filterOnChange = _ref$filterOnChange === void 0 ? false : _ref$filterOnChange,
    handleOnSubmit = _ref.handleOnSubmit,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "de" : _ref$lang,
    localValues = _ref.localValues,
    preSelectedValues = _ref.preSelectedValues,
    refForm = _ref.refForm,
    _ref$selectedFilter = _ref.selectedFilter,
    selectedFilter = _ref$selectedFilter === void 0 ? [] : _ref$selectedFilter,
    setLocalValues = _ref.setLocalValues;
  var defaultFilter = (0, _useFilterAPI.default)(_objectSpread({
    api: api,
    lang: lang
  }, localValues));
  var handleChange = function handleChange(identifier, value, resetAll) {
    var _tmpLocalValues$ident;
    var tmpLocalValues = JSON.parse(JSON.stringify(localValues));
    var tmpValue = (_tmpLocalValues$ident = tmpLocalValues === null || tmpLocalValues === void 0 ? void 0 : tmpLocalValues[identifier]) !== null && _tmpLocalValues$ident !== void 0 ? _tmpLocalValues$ident : [];
    if ((0, _isArray.default)(tmpValue)) {
      var index = tmpValue === null || tmpValue === void 0 ? void 0 : tmpValue.indexOf(value);
      if (index > -1) {
        tmpValue.splice(index, 1);
      } else {
        tmpValue.push(value);
      }
    }
    if (resetAll) {
      tmpLocalValues[identifier] = [];
    } else {
      tmpLocalValues[identifier] = tmpValue;
    }
    setLocalValues(tmpLocalValues);
    if (filterOnChange) {
      setTimeout(function () {
        var evt = new CustomEvent("submit", {
          bubbles: true,
          cancelable: true
        });
        refForm.current.dispatchEvent(evt);
      }, 10);
    }
  };
  var selectedFilterOptions = (0, _react.useMemo)(function () {
    if (!(0, _isEmpty.default)(selectedFilter)) return selectedFilter;
    var options = [];
    for (var key in defaultFilter) {
      var _ref2 = defaultFilter[key] || {},
        type = _ref2.type;
      if (type === "checkbox" && excludedFilter.indexOf(key) === -1) options.push(key);
    }
    return options;
  }, [defaultFilter, excludedFilter, selectedFilter]);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "mco-filter",
    ref: refForm,
    onSubmit: function onSubmit(e) {
      if (handleOnSubmit) {
        handleOnSubmit(e);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_filterContext.default.Provider, {
    value: {
      defaultFilter: defaultFilter,
      localValues: localValues,
      preSelectedValues: preSelectedValues,
      selectedFilter: selectedFilterOptions,
      setLocalValues: setLocalValues,
      onChange: handleChange
    }
  }, children));
};
var _default = Filter;
exports.default = _default;